import { HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { CoreStore } from "../store/core.store";

export const loadingInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
  const core = inject(CoreStore);
  core.beginNetwork();
  return next(req).pipe(finalize(() => core.endNetwork()));
};
